/**
 * Spec Console の oRPC contract のうち、機能を問わず共有するもの。
 *
 * 全 procedure が共有するエラー集合と、それを載せた contract builder、機能に属さない
 * auth feature（`me`）を持つ。機能ごとの contract は `contract/` の各ファイルが持ち、
 * `contract/index.ts` が束ねる。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business Spec Console の oRPC contract が機能を問わず共有するエラー集合・builder・auth feature を定義する。
 * @graph-connects none
 */
import { oc } from '@orpc/contract';
import { SpecConsoleCurrentUserResponseSchema } from '../auth.js';
/**
 * 全 procedure が共有するエラー集合。
 *
 * 閲覧専用サービスなので書き込み系（CONFLICT 等）は持たない。
 * @graph-connects none
 */
export const SHARED_ERRORS = {
    UNAUTHORIZED: { message: 'ログインが必要です' },
    FORBIDDEN: { message: 'アクセス権限がありません' },
    NOT_FOUND: { message: 'リソースが見つかりません' },
    BAD_REQUEST: { message: 'リクエストが不正です' },
    INTERNAL_SERVER_ERROR: { message: '内部エラーが発生しました' },
};
/**
 * 読取 13 本（監査 2 本を除く）・担当者かの照合（`getApprovalAccess`）・`auth.me` が使う contract builder。
 * @graph-connects none
 */
export const base = oc.errors(SHARED_ERRORS);
/**
 * auth feature の oRPC contract（me）。
 *
 * login は Edge Router Worker が所有するため contract に現れない。logout も骨格フェーズでは
 * 持たない。ログアウトはサーバー側セッション失効を伴い、セッションストアの配線が前提になる
 * ので、その配線と同時に足す。
 * @graph-connects none
 */
export const authContract = {
    me: base.output(SpecConsoleCurrentUserResponseSchema),
};
//# sourceMappingURL=common.js.map